import { useEffect, useRef } from "react";
import type {
  AdditionalDetailsData,
  AdyenCheckoutError,
  PaymentAction,
} from "@adyen/adyen-web";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Dialog, DialogContent, Loading } from "@tenant/ui";
import styles from "./AdyenActionComponent.module.scss";
import { useAdyen } from "./useAdyen";

const ADYEN_CONTAINER_ID = "adyen-3ds-container";

interface AdyenActionComponentProps {
  should3DSDialogOpen: boolean;
  on3DSDialogOpenChange: (open: boolean) => void;
  paymentAction: PaymentAction;
  locale: string;
  countryCode: string;
  onSuccess: (state: AdditionalDetailsData) => void;
  onError: (error: AdyenCheckoutError) => void;
}

export const AdyenActionComponent = (props: AdyenActionComponentProps) => {
  const [block, cn] = useModuleBEM(styles, "AdyenActionComponent");
  const {
    should3DSDialogOpen,
    on3DSDialogOpenChange,
    paymentAction,
    locale,
    countryCode,
    onSuccess,
    onError,
  } = props;
  const { isLoading, element } = useAdyen({
    paymentAction,
    locale,
    countryCode,
    onSuccess,
    onError,
  });
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current != null) {
      element?.mount(ref.current);
    }
  }, [element]);

  return (
    <Dialog open={should3DSDialogOpen} onOpenChange={on3DSDialogOpenChange}>
      <DialogContent showCloseButton={false} className={block}>
        <div
          ref={ref}
          id={ADYEN_CONTAINER_ID}
          className={cn("adyen-container")}
        />
        {isLoading && <Loading className={cn("loading")} />}
      </DialogContent>
    </Dialog>
  );
};
